export const DOMAIN = import.meta.env.VITE_BACKEND_DOMAIN;
